module.exports = __webpack_public_path__ + "static/img/logo-adherencia.3ccbf21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-adherencia.png
// module id = Tqdx
// module chunks = 1